import http from "../../api/http";

export default {
  namespaced: true,
  state: {
    currentLicense: null,
    licenseFetched: false,
  },
  mutations: {
    setCurrentLicense(state, license) {
      state.currentLicense = license;
      state.licenseFetched = true;
    },
    clearLicense(state) {
      state.currentLicense = null;
      state.licenseFetched = false;
    },
  },
  actions: {
    async fetchCurrentLicense({ commit, state }) {
      // Si la licence a déjà été récupérée, ne pas refaire la requête
      if (state.licenseFetched) {
        return state.currentLicense;
      }

      try {
        const response = await http.get('licenses/current');
        const license = response.data?.data || response.data || null;
        commit('setCurrentLicense', license);
        return license;
      } catch (err) {
        console.error('Erreur lors du chargement de la licence:', err);
        commit('setCurrentLicense', null);
        return null;
      }
    },
  },
  getters: {
    currentLicense: (state) => state.currentLicense,
    isLicenseExpired: (state) => {
      return state.currentLicense && 
             (state.currentLicense.status === 'expired' || state.currentLicense.status === 'expiree');
    },
  },
};
